import { Component } from '@theme/component';

/**
 * PPC Featured Deal slideshow.
 *
 * Slides live as direct children of `track`, each 100% wide. JS translates
 * the track to bring the active slide into view and toggles the prev/next
 * buttons' disabled state at the ends. Arrows are only rendered (in the
 * Liquid template) when there are 2+ slides, so this script becomes a no-op
 * for single-slide deployments.
 *
 * @extends Component<{ track: HTMLElement, prevBtn?: HTMLButtonElement, nextBtn?: HTMLButtonElement }>
 */
class PvPpcFeaturedDeal extends Component {
  requiredRefs = ['track'];

  #index = 0;

  connectedCallback() {
    super.connectedCallback();
    const { prevBtn, nextBtn } = this.refs;
    prevBtn?.addEventListener('click', () => this.#go(-1));
    nextBtn?.addEventListener('click', () => this.#go(1));
    this.#syncState();
  }

  #slideCount() {
    return this.refs.track.children.length;
  }

  #go(direction) {
    const count = this.#slideCount();
    if (count <= 1) return;
    this.#index = Math.min(count - 1, Math.max(0, this.#index + direction));
    this.#syncState();
  }

  #syncState() {
    const { track, prevBtn, nextBtn } = this.refs;
    const count = this.#slideCount();
    track.style.transform = `translateX(-${this.#index * 100}%)`;

    if (prevBtn) prevBtn.toggleAttribute('disabled', this.#index === 0);
    if (nextBtn) nextBtn.toggleAttribute('disabled', this.#index >= count - 1);
  }
}

if (!customElements.get('pv-ppc-featured-deal')) {
  customElements.define('pv-ppc-featured-deal', PvPpcFeaturedDeal);
}
